import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AppConsts from '@/lib/AppConsts';
import UrlHelper from '@/lib/utils/url-helper';
import { StartUp } from '@/lib/startup';
import ExternalLoginService from '@/lib/auth/ExternalLoginService';
import { TokenAuthServiceProxy } from '@/lib/service-proxy/TokenAuthServiceProxy';
import { ExternalAuthenticateCodeModel } from '@/lib/service-proxy/ExternalAuthenticateCodeModel';
var Callback = /** @class */ (function (_super) {
    tslib_1.__extends(Callback, _super);
    function Callback() {
        var _this = _super.call(this) || this;
        _this.tokenService = new TokenAuthServiceProxy();
        _this.externalLoginService = new ExternalLoginService();
        return _this;
    }
    Callback.prototype.mounted = function () {
        var params = UrlHelper.getQueryParameters();
        var vm = this;
        if (params.code && params.state) {
            var stateModel_1 = this.externalLoginService.getStateModel(decodeURIComponent(params.state));
            var externalAuthenticateCodeModel = new ExternalAuthenticateCodeModel();
            externalAuthenticateCodeModel.provider = stateModel_1.provider;
            externalAuthenticateCodeModel.state = params.state;
            externalAuthenticateCodeModel.code = params.code;
            this.tokenService.externalAuthenticateWithCode(externalAuthenticateCodeModel)
                .then(function (result) {
                abp.auth.setToken(result.accessToken);
                abp.utils.setCookieValue(AppConsts.authorization.encrptedAuthTokenName, result.encryptedAccessToken, undefined, abp.appPath);
                StartUp().then(function () {
                    vm.$router.replace(stateModel_1.returnUrl);
                });
            }).catch(function (error) {
                // if (error) {
                //     vm.$router.replace({name: 'home'});
                // }
            });
        }
        else {
            window.history.forward();
            location.replace(process.env.BASE_URL || abp.appPath);
        }
    };
    Callback = tslib_1.__decorate([
        Component({})
    ], Callback);
    return Callback;
}(Vue));
export default Callback;
